// Recent searches, kept in this browser only (shown when the search box is
// focused and empty). Storage can be unavailable, e.g. in private mode.
const KEY = 'recentSearches';
const MAX = 6;

export const getRecentSearches = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((q) => typeof q === 'string') : [];
  } catch {
    return [];
  }
};

export const addRecentSearch = (query) => {
  try {
    const list = [query, ...getRecentSearches().filter((q) => q !== query)];
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    // ignore
  }
};

export const clearRecentSearches = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
};
